/**
 * Motowheeler PDP — gallery, tabs, variants, qty, sticky ATC
 */
(() => {
  const root = document.querySelector('[data-main-product]');
  if (!root) return;

  const sectionId = root.getAttribute('data-section-id');
  const productJson = document.getElementById(`ProductJson-${sectionId}`);
  let productData = null;
  try {
    productData = productJson ? JSON.parse(productJson.textContent) : null;
  } catch {
    productData = null;
  }

  const moneyFormat =
    window.Shopify?.currency?.active && window.theme?.moneyFormat
      ? window.theme.moneyFormat
      : null;

  const formatMoney = (cents) => {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, moneyFormat || undefined);
    }
    const n = (Number(cents) / 100).toFixed(2);
    return `₹${n.replace(/\.00$/, '')}`;
  };

  /* —— Gallery —— */
  const gallery = root.querySelector('[data-product-gallery]');
  let showGalleryIndex = () => {};
  let showGalleryMedia = () => {};

  if (gallery) {
    const items = [...gallery.querySelectorAll('.main-product__media-item')];
    const thumbs = [...gallery.querySelectorAll('[data-thumb-for]')];
    const dots = [...gallery.querySelectorAll('[data-gallery-dots] span')];
    let index = Math.max(
      0,
      items.findIndex((el) => el.classList.contains('is-active'))
    );

    const show = (i) => {
      if (!items.length) return;
      index = (i + items.length) % items.length;
      items.forEach((el, n) => el.classList.toggle('is-active', n === index));
      thumbs.forEach((el, n) => el.classList.toggle('is-active', n === index));
      dots.forEach((el, n) => el.classList.toggle('is-active', n === index));
    };

    showGalleryIndex = show;
    showGalleryMedia = (mediaId) => {
      if (!mediaId) return;
      const idx = items.findIndex(
        (el) => String(el.getAttribute('data-media-id')) === String(mediaId)
      );
      if (idx >= 0) show(idx);
    };

    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(index - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(index + 1));
    thumbs.forEach((btn, n) => btn.addEventListener('click', () => show(n)));

    const stage = gallery.querySelector('[data-gallery-stage]');
    if (stage && items.length > 1) {
      let startX = 0;
      stage.addEventListener(
        'pointerdown',
        (e) => {
          startX = e.clientX;
        },
        { passive: true }
      );
      stage.addEventListener('pointerup', (e) => {
        const dx = e.clientX - startX;
        if (Math.abs(dx) < 40) return;
        show(dx < 0 ? index + 1 : index - 1);
      });
    }
  }

  /* —— Tabs —— */
  root.querySelectorAll('[data-product-tabs]').forEach((tabs) => {
    tabs.querySelectorAll('[data-tab]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = btn.getAttribute('data-tab');
        tabs.querySelectorAll('[data-tab]').forEach((b) => {
          const on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', String(on));
        });
        tabs.querySelectorAll('[data-panel]').forEach((panel) => {
          const on = panel.getAttribute('data-panel') === id;
          panel.classList.toggle('is-active', on);
          panel.hidden = !on;
        });
      });
    });
  });

  /* —— Qty —— */
  root.querySelectorAll('[data-qty-stepper]').forEach((stepper) => {
    const input = stepper.querySelector('.qty-stepper__input');
    if (!input) return;
    stepper.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      input.value = Math.max(1, Number(input.value || 1) - 1);
    });
    stepper.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      input.value = Math.max(1, Number(input.value || 1) + 1);
    });
  });

  /* —— Variants —— */
  const form = root.querySelector('[data-product-form]');
  const variantInput = form?.querySelector('[data-variant-id]');
  const atcBtn = form?.querySelector('[data-atc-btn]');
  const atcLabel = form?.querySelector('[data-atc-label]');
  const atcPrice = form?.querySelector('[data-atc-price]');
  const stickyPrice = root.querySelector('[data-sticky-price]');
  const stickyBtn = root.querySelector('[data-sticky-atc-btn]');
  const saveEl = root.querySelector('[data-product-save]');
  const priceWrap = root.querySelector('[data-product-price]');

  const optionBlocks = [...root.querySelectorAll('[data-option-index]')];

  const getSelectedOptions = () =>
    optionBlocks.map((block) => {
      const input = block.querySelector('[data-option-input]');
      return input ? input.value : '';
    });

  const updateVariant = () => {
    if (!productData || !optionBlocks.length) return;
    const selected = getSelectedOptions();
    const variant = productData.variants.find((v) =>
      selected.every((val, i) => String(v[`option${i + 1}`]) === String(val))
    );

    if (!variant) {
      if (atcBtn) atcBtn.disabled = true;
      if (atcLabel) atcLabel.textContent = 'Unavailable';
      if (stickyBtn) stickyBtn.disabled = true;
      return;
    }

    if (variantInput) variantInput.value = variant.id;
    const money = formatMoney(variant.price);
    if (atcPrice) atcPrice.textContent = money;
    if (stickyPrice) stickyPrice.textContent = money;

    if (atcBtn) atcBtn.disabled = !variant.available;
    if (stickyBtn) stickyBtn.disabled = !variant.available;
    if (atcLabel) {
      atcLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
    }

    if (priceWrap) {
      const sale = priceWrap.querySelector('.price__sale, .price__regular');
      const compare = priceWrap.querySelector('.price__compare');
      if (sale) sale.textContent = money;
      if (variant.compare_at_price > variant.price) {
        if (compare) {
          compare.hidden = false;
          compare.textContent = formatMoney(variant.compare_at_price);
        }
        if (saveEl) {
          saveEl.hidden = false;
          saveEl.textContent = `Save ${formatMoney(variant.compare_at_price - variant.price)}`;
        }
      } else {
        if (compare) compare.hidden = true;
        if (saveEl) saveEl.hidden = true;
      }
    }

    /* Swap gallery to the variant’s featured media */
    const mediaId = variant.featured_media?.id || variant.featured_image?.id;
    if (mediaId) showGalleryMedia(mediaId);

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  };

  optionBlocks.forEach((block) => {
    const input = block.querySelector('[data-option-input]');
    const label = block.querySelector('[data-color-label]');
    block.querySelectorAll('[data-option-btn]').forEach((btn) => {
      btn.addEventListener('click', () => {
        block.querySelectorAll('[data-option-btn]').forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        const val = btn.getAttribute('data-option-value') || '';
        if (input) input.value = val;
        if (label) label.textContent = val;
        updateVariant();
      });
    });
  });

  /* Sync gallery to the currently selected variant on load */
  if (productData && optionBlocks.length) updateVariant();
  else if (productData?.selected_or_first_available_variant?.featured_media?.id) {
    showGalleryMedia(productData.selected_or_first_available_variant.featured_media.id);
  } else {
    const selectedId = variantInput?.value;
    const selected = productData?.variants?.find((v) => String(v.id) === String(selectedId));
    if (selected?.featured_media?.id) showGalleryMedia(selected.featured_media.id);
  }
  /* —— Sticky ATC —— */
  const sticky = root.querySelector('[data-sticky-atc]');
  const mainAtc = root.querySelector('.main-product__atc');
  if (sticky && mainAtc && 'IntersectionObserver' in window) {
    let atcOut = false;
    let relatedIn = false;
    const sync = () => sticky.classList.toggle('is-visible', atcOut && !relatedIn);

    new IntersectionObserver(([entry]) => {
      atcOut = !entry.isIntersecting;
      sync();
    }).observe(mainAtc);

    const related = document.querySelector('.product-rail-section');
    if (related) {
      new IntersectionObserver(
        ([entry]) => {
          relatedIn = entry.isIntersecting;
          sync();
        },
        { rootMargin: '0px 0px -80px 0px', threshold: 0 }
      ).observe(related);
    }
  }
})();
